import React, {Component} from "react";
import PropTypes from "prop-types";
import gsap from "gsap";
import {SvcConsulting, SvcEsports, SvcGaming, SvcIngame} from "../Services/SvcContent";
import './pServices.css';
import {Accordion, AccordionDetails, AccordionSummary} from "@material-ui/core";
import {getFM} from "../../Utilities/utils";
import MainMenu from "../menu/menu";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {injectIntl} from "react-intl";
import {ContactIcon} from "../menu/MenuIcons";
import BgGrid from "../BgGrid";
import {logEvent} from "../../Utilities/AmplitudeService";

class PServices extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isAnimating: false,
            selectedItem: {},
            selectedIndex: -1,
            lastSelectedIndex: -1
        };


        this.changeIndex = this.changeIndex.bind(this);
        this.sectionsProps = [{
            text: 'IGA',
            content: SvcIngame(this.props, this.props.intl.messages),
            scroll: 1
        },
            {
                text: 'consulting',
                content: SvcConsulting(this.props, this.props.intl.messages),
                scroll: 0
            }, {
                text: 'experiences',
                content: SvcGaming(this.props, this.props.intl.messages),
                scroll: 0
            }, {
                text: 'esports',
                content: SvcEsports(this.props, this.props.intl.messages),
                scroll: 0
            }
        ];

        this.timeline = null
        this.services = null
        this.summaries = null
    }

    componentDidMount() {
        logEvent('page_loaded');
        window.scrollTo(0, 0);
        this.services = this.sectionsProps.map((section, index) => {
            return "#a" + index
        })
        this.summaries = this.sectionsProps.map((section, index) => {
            return "#summary" + index
        })
        this.isRedirectFromHome = this.props.location.state != null
        if (this.isRedirectFromHome) {
            this.openService();
        }
        this.hideContactIcon()
    }

    openService() {
        let openService = this.props.location.state.openService
        document.getElementById("summary" + openService).click()
        this.showContactIcon()
    }

    setAnimation(index) {
        const hiddenServices = this.services.filter((element) => {
            return element !== "#a" + index
        })
        const hiddenSummaries = this.summaries.filter((element) => {
            return element !== "#summary" + index
        })

        const hiddenElements = [...hiddenServices, ...hiddenSummaries]
        this.timeline = gsap.timeline({duration: 0.5})
            .to("#a" + index, {
                height: 'initial',
            }, 0)
            .to(hiddenElements, {
                height: 0,
                opacity: 0,
            }, 0).to(hiddenElements, {
                display: 'none'
            }, 0.1)
    }


    changeIndex(index: number) {

        if (this.state.isAnimating) {
            return;
        }

        this.setState({
            isAnimating: true
        });

        if (!this.isRedirectFromHome && this.isSelectedServiceOpen(index)) {
            this.closeServiceAnimation(index);
            this.hideContactIcon()

        } else {
            const p = this.sectionsProps[index];
            this.isRedirectFromHome = false
            this.openServiceAnimation(index);
            this.setScroll(p.scroll);
            this.showContactIcon()
        }

    }

    scrollHandler() {
        if (this.isIGA())
            this.showScrollIcon()
        else
            this.hideScrollIcon()
    }

    isIGA() {
        return this.state.selectedIndex == 0
    }

    showScrollIcon() {
        document.getElementById("scroll-icon").style.display = "block"
    }

    hideScrollIcon() {
        document.getElementById("scroll-icon").style.display = "none"
    }

    hideContactIcon() {
        document.getElementById("mail").style.display = "none"
    }

    showContactIcon() {
        document.getElementById("mail").style.display = "block"
    }

    isSelectedServiceOpen(index) {
        return this.state.selectedIndex == index;
    }

    openServiceAnimation(index) {
        this.setState({isAnimating: false, selectedIndex: index, lastSelectedIndex: index}, () => {
            this.setAnimation(index)
            this.timeline.play()
            this.scrollHandler()
        })
    }

    closeServiceAnimation() {
        this.setState({isAnimating: false, selectedIndex: -1}, () => {
            this.timeline.reverse()
            this.scrollHandler()
        })
    }

    isSelectedService(index) {
        return this.state.lastSelectedIndex == index;
    }

    setScroll(opacity) {
        gsap.to('.icon-scroll', {
            duration: 0.2,
            opacity: opacity,
        })
    }

    isMenuClosed() {
        return this.state.selectedIndex == -1;
    }


    render() {

        return <>
            <section id={'svcId'} className={"p-services-container"}>
                {this.state.selectedIndex < 0 && <BgGrid className={'pservices-bg-grid'} id={'p-bg2'}
                                                         hLines={5} vLines={4} style={{}}/>}
                <div id='content' className={"p-services-content" + this.props.className}>
                    {this.sectionsProps.map((value, index) => {
                        return <Accordion
                            id={'a' + index} elevation={2}
                            className={`sc-acc sc-acc-${value.text} `}
                            prefix={'sc-acc'}
                            key={index}
                            ref={value.text}
                        >
                            <AccordionSummary id={'summary' + index}
                                              className={this.isSelectedService(index) && this.isMenuClosed() ? `sc-acc-summary p-font-menu sc-acc-show selected-service ` : `sc-acc-summary p-font-menu sc-acc-show `}
                                              onClick={() => this.changeIndex(index)}
                                              expandIcon={this.isSelectedService(index) &&
                                              <ExpandMoreIcon
                                                  className={this.isSelectedService(index) && this.isMenuClosed() ? `selected-service ` : ` `}
                                                  fontSize={"large"}/>}
                            >
                                {getFM('home_' + value.text + '_title')}
                            </AccordionSummary>
                            <AccordionDetails>
                                {value.content}
                            </AccordionDetails>
                        </Accordion>
                    })}
                </div>
            </section>
            <MainMenu showPopup={false}
                      topMenu={'transparent'} colorX={'#FFFFFF'}
                      autoPlay={true}
                      iconScroll={'icon-scroll-left'}
                      hide={['#to-top-icon', '#contact-icon', '#ac', '#at', "#scroll-icon"]}
                      scroll={this.state.selectedItem.scroll}
                      triggerId={'#svcId'} end={'top -15%'}/>

            <div id={'mail'} className="menu-icons-container mail-div-icon clickable">
                <ContactIcon id={'mail-icon'}
                             onClick={() => this.props.history.push('/contact/' + this.props.location.search)}/>
            </div>

        </>
    }
}

PServices.propTypes = {
    selectedIndex: PropTypes.number,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.element,
    clickEvent: PropTypes.func,
    fill: PropTypes.string,
}

PServices.defaultProps = {
    selectedIndex: -1,
    fill: '#fff',
    classText: '',
    className: '',
    state: {}
}

export default injectIntl(PServices);

